<template>
  <div class="brands-list">
    <Loader v-if="offers_being_loaded" />
     <template v-else>
      <section class="pt-0">
        <div id="home_section" class="home-section multi-slider">
        <offer-page :offers="getFilteredOffers" />
        </div>
    </section>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OfferPage from '@/components/Collections/OfferPage'
import Loader from '@/components/Elements/Loader'
export default {
  name: 'Catalog',
  components: {
      OfferPage,
      Loader,
  },
  computed: {
    offers_being_loaded()
    {
        if (this.domainBasedBrand)
        {
           return this.all_brand_offers_being_loaded
        }
        return this.all_goorder_offers_being_loaded
    },
    ...mapGetters(['all_goorder_offers_being_loaded', 'all_brand_offers_being_loaded', 'getFilteredOffers', 'domainBasedBrand'])
  },
  
}
</script>
<style lang="scss" scoped>
.no-da-selected {
  padding: 2rem;
  font-size: $px24;
  text-align: center;
  color: $color-primary;
  font-weight: 600;
  display: flex;
  justify-content: space-around;
}
.rightarrow {
  width: $px16;
  height: $px16;
}
.brands-list {
  div {
    &:first-child {
      .product-section {
        padding-top: calc(
          30px + (80 - 30) * ((100vw - 320px) / (1920 - 320))
        ) !important;
      }
    }
  }
}
.brands-container {
  padding: 4rem;
  .brands-header {
    font-size: 2rem;
    padding-bottom: 4rem;
  }
}
@media (max-width: 767px) {
  .fixed-mp-cls {
    margin-bottom: $px60;
  }
}
@media (max-width: 575px) {
  .main_section {
    border-top: $px12 solid #edeff4;
    padding-top: $px16 !important;
    margin-top: $px16;
    margin-bottom: 0;
    min-height: 50vh !important;
  }
  .brands-list {
    > div {
      &:last-child {
        margin-bottom: $px60 !important;
      }
    }
  }
}
</style>
